import { useEffect, useRef } from 'react'
import deepEqual from 'dequal'

const useDeepCompare = (deps) => {
  const ref = useRef()

  if (!deepEqual(ref.current, deps)) {
    ref.current = deps
  }

  return ref.current
}

export const useDeepEffect = (callback, deps) => {
  useEffect(callback, useDeepCompare(deps))
}

export const usePrevious = (value) => {
  const ref = useRef()

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}



// WEBPACK FOOTER //
// ./src/utils/hooks.js